module.exports = __webpack_public_path__ + "static/laundromatslider-03-min-98455b5c01f4e87b027fd9a5443c7598.jpg";